var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"countDown"}},[_vm._v("\n  "+_vm._s(_vm.$t("vip_center_page.count_down"))+_vm._s(_vm.timeStr)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }